/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */
import mergeProps from "@/router/utils/mergeProps";

let DashboardMainPage = () => import(/* webpackChunkName: "DashboardModule" */ '@/core/recoveryCoachingApp/coach/dashboard/DashboardMainPage.vue')
let DashboardListPage = () => import(/* webpackChunkName: "DashboardModule" */ '@/core/recoveryCoachingApp/coach/dashboard/DashboardListPage/DashboardListPage')
let DashboardCalendarPage = () => import(/* webpackChunkName: "DashboardModule" */ '@/core/recoveryCoachingApp/coach/dashboard/DashboardCalendarPage/DashboardCalendarPage')

export default [

	{
		path: 'dashboard',
		name: 'DashboardMainRoute',
		component: DashboardMainPage,
		props: mergeProps,
		redirect: {name: 'DashboardListRoute'},
		children: [
			{
				path: 'list',
				name: 'DashboardListRoute',
				meta: {dashboardType: 'list'},
				component: DashboardListPage,
				props: mergeProps,
			},
			{
				path: 'calendar',
				name: 'DashboardCalendarRoute',
				meta: {dashboardType: 'calendar'},
				component: DashboardCalendarPage,
				props: mergeProps,
			},

		]
	},




]


